import {PageEvent} from '@spartacus/storefront';

export class ConfiguratorPageEvent extends PageEvent {}
